module.exports = __webpack_public_path__ + "img/habanero.f4b8dc0d.png";